import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from "react-toastify";
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {ValidationRules} from "./ValidationRules";
import FormValidator from "../../validations/FormValidator";
import StaffDasboardService from "../../services/StaffDasboardService";
import ErrorMsg from "../common/ErrorMsg";

export default class ProfileModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profileDetail: {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                job_title: '',
                department_name: '',
                emergency_contact: '',
                hire_date: '',
                birth_date: null,
                image_path: null
            },
            errors: {},
        };
        this.validator = new FormValidator(ValidationRules);
    };

    getInitialState = async() => {
        let result = await StaffDasboardService.getUserProfile();
        if(200 === result.status) {
            let profileDetail = {...result.data};
            profileDetail.birth_date = profileDetail.birth_date ? moment(profileDetail.birth_date) : null;
            this.setState({profileDetail});
        }
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    toggleModal = () => {
       this.props.toggleProfileModal();
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let profileDetail = {...this.state.profileDetail};
        profileDetail[name] = value;
        this.setState({profileDetail});
    };

    phoneChange = (values) => {
        const {value} = values;
        let profileDetail = {...this.state.profileDetail};
        profileDetail['phone'] = value;
        this.setState({profileDetail});
    }

    fileChangedHandler = (e) => {
        let name = e.currentTarget.name;
        let profileDetail = {...this.state.profileDetail};
        profileDetail[name] = e.target.files[0];
        this.setState({profileDetail});
    };

    getFormData = (object) => {
        const formData = new FormData();
        Object.keys(object).forEach(key => {
            if (!(key === 'birth_date' && !object[key])) {
                formData.append(key, object[key]);
            } 
            
        });
      return formData;
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date) => {
        let profileDetail = {...this.state.profileDetail};
        profileDetail['birth_date'] = date;
        this.setState({profileDetail});
    };

    updateProfile = async (e) => {
        e.preventDefault();
        const profileDetail = {...this.state.profileDetail};
        profileDetail['birth_date'] = profileDetail.birth_date ? moment(profileDetail.birth_date).format("YYYY-MM-DD") : null;
        let validationStatus = this.validator.validateForm(profileDetail);
        if (!validationStatus.isValid) {
            this.setState((prevState) => ({
                errors: validationStatus.errors,
            }));
        } else {
            // Image not being uploaded by user
            if (!profileDetail.image_path || typeof(profileDetail.image_path) === "string") {
                delete profileDetail['image_path']
            }

            // Convert to FormData before sending to server
            const profileFormData = this.getFormData(profileDetail);
            try {
                let result = await this.props.actions.StaffDashboard.updateProfile(profileFormData);
                if (result) {
                    toast.success("Profile updated successfully.");
                    this.toggleModal();
                }
            } catch(error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    render() {
        const {profileDetail, errors} = this.state;
        return (
            <Modal isOpen={this.props.openProfileModal} size="lg" toggle={this.toggleModal}>
                <ModalHeader toggle={this.toggleModal}>
                    Edit Profile
                </ModalHeader>
                <form>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>First Name: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input type="text" className="form-control" name="first_name" value={profileDetail.first_name ? profileDetail.first_name : ''} onChange={this.handleChange} />
                            {errors.first_name ? <span className="span-error">{errors.first_name}</span> : ''}
                        </div>
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Last Name: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input type="text" className="form-control" name="last_name" value={profileDetail.last_name ? profileDetail.last_name : ''} onChange={this.handleChange} />
                            {errors.last_name ? <span className="span-error">{errors.last_name}</span> : ''}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Phone: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <NumberFormat format="(###) ###-####" mask="_" value={profileDetail.phone ? profileDetail.phone : ''} onValueChange={(values) => this.phoneChange(values)} className="form-control" name="phone" />
                            {errors.phone ? <span className="span-error">{errors.phone}</span> : ''}
                        </div>
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Email: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input disabled={true} type="text" className="form-control" name="email" value={profileDetail.email ? profileDetail.email : ''} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Emergency Contact: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input type="text" className="form-control" name="emergency_contact" value={profileDetail.emergency_contact ? profileDetail.emergency_contact : ''} onChange={this.handleChange} />
                        </div>
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Department: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input disabled={true} type="text" className="form-control" name="department_name" value={profileDetail.department_name ? profileDetail.department_name : ''} />
                        </div>
                    </div>

                    <div className="row">
                    <div className="col-sm-2 text-sm-right pt-2">
                            <label>Birth Date: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <DatePicker
                                selected={profileDetail.birth_date} onChangeRaw={this.handleDateChangeRaw}
                                onChange={(event) => this.handleDateChange(event)}
                                dateFormat="MM/DD/YYYY" fixedHeight
                                showMonthDropdown showYearDropdown
                                keepFocus={false}
                                dropdownMode="select" className="form-control"
                                minDate={moment('1900-01-01')}
                                maxDate={moment()}
                                autoComplete="off"
                            />
                        </div>
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Job Title: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input disabled={true} type="text" className="form-control" name="job_title" value={profileDetail.job_title ? profileDetail.job_title : ''} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Profile Picture: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input type="file" accept="image/*" className="form-control" name="image_path" onChange={this.fileChangedHandler} />
                        </div>
                        <div className="col-sm-2 text-sm-right pt-2">
                            <label>Hire Date: </label>
                        </div>
                        <div className="col-sm-4 mb-3">
                            <input disabled={true} type="text" className="form-control" name="hire_date" value={profileDetail.hire_date ? profileDetail.hire_date : ''} />
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button type="submit" className='btn btn-success' onClick={this.updateProfile}>Update</Button>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboard/ProfileModal.js